import UpdatePasswordForm from "./UpdatePassword";
export default UpdatePasswordForm;
